export function guideValidate(guide){
    var result = true;

    result = validateId(guide.id);
    result = validateCustomer(guide.customer);    
    result = validateShippingService(guide.shipping_service);
    result = validateAccount(guide.account);
    result = validateGuide(guide.guide);
    result = validateDate(guide.date);
    result = validateWeight(guide.weight)
    result = validatePacking(guide.packing);
    result = validateVolumetricWeight(guide.volumetric_weight);
    result = validateInsuranceAmount(guide.insurance_amount);
    result = validateOrigin(guide.origin);
    result = validateDestination(guide.destination);
    result = validateZone(guide.zone);
    result = validateExtendedZone(guide.extended_zone);
    result = validateStatus(guide.status);
    result = validateGuideCharge(guide.guide_charge);
    
    return result;
}

function validateId(id){    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateCustomer(customer){
    if(typeof customer === 'string' && customer.trim() !== '') return true;
    else return false;
}

function validateShippingService(shipping_service){
    if(typeof shipping_service === 'string' && shipping_service.trim() !== '') return true;
    else return false;
}

function validateAccount(account){
    if(typeof account === 'string' && account.trim() !== '') return true;
    else return false;
}

function validateGuide(guide){
    if(typeof guide === 'string' && guide.trim() !== '') return true;
    else return false;
}

function validateDate(date){
    if(typeof date === 'string' && date.trim() !== '' && date.length == 10) return true;
    else return false;
}

function validateWeight(weight){
    if(typeof weight === 'string' && weight.trim() !== '') return true;
    else return false;
}

function validatePacking(packing){
    if(typeof packing === 'string' && packing.trim() !== '') return true;
    else return false;
}

function validateVolumetricWeight(volumetric_weight){
    if(typeof volumetric_weight === 'string' && volumetric_weight.trim() !== '') return true;
    else return false;
}

function validateInsuranceAmount(insurance_amount) {
    if(typeof insurance_amount === 'number' || insurance_amount == null) return true;
    else return false;
}

function validateOrigin(origin){
    if(typeof origin === 'string' && origin.trim() !== '') return true;
    else return false;
}

function validateDestination(destination){
    if(typeof destination === 'string' && destination.trim() !== '') return true;
    else return false;
}

function validateZone(zone){
    if(Number.isInteger(zone)) return true;
    else return false;
}

function validateExtendedZone(extended_zone){
    if(typeof extended_zone === 'boolean') return true;
    else return false;
}

function validateStatus(status){
    return Array.isArray(status) &&
        status.length > 0 &&
        status.every(item =>
        typeof item === 'object' &&
        item !== null &&
        typeof item.id === 'number' &&
        !isNaN(item.id) &&
        typeof item.status === 'string' &&
        item.status.trim() !== ''&&
        typeof item.date === 'string' &&
        item.date.trim() !== ''
    );
}

function validateGuideCharge(guide_charge){
    console.log(guide_charge)
    
    // if(typeof guide_charge.name !== 'string' || guide_charge.name.trim() === '') return false;
    // if(typeof guide_charge.country !== 'string' || guide_charge.country.trim() === '') return false;
    // if(typeof guide_charge.state !== 'string' || guide_charge.state.trim() === '') return false;
    // if(typeof guide_charge.municipality !== 'string' || guide_charge.municipality.trim() === '') return false;
    // if(typeof guide_charge.neighborhood !== 'string' || guide_charge.neighborhood.trim() === '') return false;
    // if(typeof guide_charge.street_line !== 'string' || guide_charge.street_line.trim() === '') return false;
    // if(typeof guide_charge.postal_code !== 'string' || guide_charge.postal_code.trim() === '') return false;
    // if(typeof guide_charge.phone !== 'string' || guide_charge.phone.trim() === '') return false;

    return true;
}